interface PeopleWithMessageCloudSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PeopleWithMessageCloudSVG = ({
  color,
  style,
}: PeopleWithMessageCloudSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_47138)">
      <path
        d="M11.9167 39C11.9167 40.7984 10.4651 42.25 8.66675 42.25C6.86841 42.25 5.41675 40.7984 5.41675 39V37.9167C5.41675 36.1184 6.86841 34.6667 8.66675 34.6667C10.4651 34.6667 11.9167 36.1184 11.9167 37.9167V39Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.16675 52V49.8333C2.16675 48.035 3.61841 46.5833 5.41675 46.5833H11.9167C13.7151 46.5833 15.1667 48.035 15.1667 49.8333V52"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M29.25 39C29.25 40.7984 27.7983 42.25 26 42.25C24.2017 42.25 22.75 40.7984 22.75 39V37.9167C22.75 36.1184 24.2017 34.6667 26 34.6667C27.7983 34.6667 29.25 36.1184 29.25 37.9167V39Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M19.5 52V49.8333C19.5 48.035 20.9517 46.5833 22.75 46.5833H29.25C31.0483 46.5833 32.5 48.035 32.5 49.8333V52"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M46.5833 39C46.5833 40.7984 45.1316 42.25 43.3333 42.25C41.5349 42.25 40.0833 40.7984 40.0833 39V37.9167C40.0833 36.1184 41.5349 34.6667 43.3333 34.6667C45.1316 34.6667 46.5833 36.1184 46.5833 37.9167V39Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.8333 52V49.8333C36.8333 48.035 38.2849 46.5833 40.0833 46.5833H46.5833C48.3816 46.5833 49.8333 48.035 49.8333 49.8333V52"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M26 5.41669V2.16669"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.6667 13H40.0834"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.9167 13H17.3334"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.6667 13H40.0834"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.9167 13H17.3334"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.0959 8.0275L37.5376 4.91833"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4624 21.0816L18.9041 17.9725"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.0959 8.0275L37.5376 4.91833"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4624 21.0816L18.9041 17.9725"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M18.9041 8.0275L14.4624 4.91833"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.5376 21.0816L33.0959 17.9725"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M18.9041 8.0275L14.4624 4.91833"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.5376 21.0816L33.0959 17.9725"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M50.9166 1.08331H1.08325V24.9166H5.77408L8.66658 29.25L11.5591 24.9166H23.1074L25.9999 29.25L28.8924 24.9166H40.4408L43.3332 29.25L46.2257 24.9166H50.9166V1.08331Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_47138">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PeopleWithMessageCloudSVG;
